//import invoices from '../assets/data/invoices'
import Vue from 'vue'
import axios from 'axios'
import * as _ from 'lodash';
import download from 'downloadjs'

export default {
    state: {
        invoices: [],
        period_date_from: void 0,
        period_date_to: void 0,
    },
    mutations: {
        fetchInvoices(state, { payload, period_date_from, period_date_to}) {
            state.invoices = payload;
            state.period_date_from = period_date_from;
            state.period_date_to = period_date_to;
        },
        createNewInvoice(state, payload) {
            // fix to prevent double insert(from http and Socket.io), check is time sheet already inserted (by this application instance)
            let invoice = _.find(state.invoices, p => p.id == payload.id);
            if (invoice) {
                return; // exit
                //? or pass to update
            }

            // check is invoice inserted in current date range
            if (state.period_date_from <= payload.period_date
                && state.period_date_to >= payload.period_date
            ) {
                state.invoices.push(payload);
            }
        },
        removeInvoice(state, payload) {
            for (let i = 0; i < state.invoices.length; i++) {
                if (payload.id == state.invoices[i].id) {
                    state.invoices.splice(i, 1); // remove item
                    break; // founded exit
                }
            }
        },
        setInvoices(state, payload) {
            state.invoices = payload;
        },
        editInvoice(state, payload) {
            const index = state.invoices.findIndex(item => item.id === payload.id);
            Vue.set(state.invoices, index, payload);
        },
        approveInvoices(state, invoices_payload) {
            for (let i = 0; i < invoices_payload.length; i++) {
                let index = state.invoices.findIndex(item => +item.id === +invoices_payload[i].id);
                if (index === -1) {
                    state.invoices.push(invoices_payload[i]);
                } else {
                    Vue.set(state.invoices, index, invoices_payload[i]);
                }
            }
        },
    },

    actions: {
        async fetchInvoices({ commit, dispatch }, {period_date_from, period_date_to}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/invoice?period_date_from=${period_date_from}&period_date_to=${period_date_to}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('fetchInvoices', {payload: data, period_date_from, period_date_to});
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async removeInvoice({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/invoice/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('removeInvoice', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async requestInvoice({commit, dispatch}, {
            invoice_number,
            comission,
            period_date_from,
            period_date_to,
            restaurant_id,
            driver_id,
            create_invoice,
        }) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let url_params = `?comission=${comission}&invoice_number=${invoice_number}&period_date_from=${period_date_from}&period_date_to=${period_date_to}`;
                if (restaurant_id) {
                    url_params = url_params + '&restaurant_id=' + restaurant_id;
                }
                if (driver_id) {
                    url_params = url_params + '&driver_id=' + driver_id;
                }
                if (create_invoice) {
                    url_params = url_params + '&create_invoice=' + create_invoice;
                }

                // window.open(`${this._vm.appConfig.app_url}/api/invoice${url_params}`);

                let response = await axios.get(`${this._vm.appConfig.app_url}/api/invoice-generate${url_params}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    responseType: 'blob',
                });

                download(response.data, `DreamDrivers Invoice ${invoice_number}.pdf`, response.headers['content-type']);

                commit('setLoading', false);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async previewInvoice({commit, dispatch}, {
            invoice_number,
            comission,
            period_date_from,
            period_date_to,
            restaurant_id,
            driver_id,
        }) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let url_params = `?comission=${comission}&invoice_number=${invoice_number}&period_date_from=${period_date_from}&period_date_to=${period_date_to}`;
                if (restaurant_id) {
                    url_params = url_params + '&restaurant_id=' + restaurant_id;
                }
                if (driver_id) {
                    url_params = url_params + '&driver_id=' + driver_id;
                }

                // window.open(`${this._vm.appConfig.app_url}/api/invoice${url_params}`);

                let response = await axios.get(`${this._vm.appConfig.app_url}/api/invoice-generate${url_params}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    responseType: 'blob',
                });

                var fileURL = URL.createObjectURL(response.data);
                window.open(fileURL,"_blank");

                commit('setLoading', false);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async downloadInvoice({commit, dispatch}, {id, invoice_number, period_date_from, period_date_to}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let response = await axios.get(`${this._vm.appConfig.app_url}/api/invoice-download/${id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    responseType: 'blob',
                });

                download(response.data, `${invoice_number}_${period_date_from}-${period_date_to}.pdf`, response.headers['content-type']);

                commit('setLoading', false);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async viewInvocie({commit, dispatch}, {id, invoice_number, period_date_from, period_date_to}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let response = await axios.get(`${this._vm.appConfig.app_url}/api/invoice-download/${id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    responseType: 'blob',
                });

                var fileURL = URL.createObjectURL(response.data);
                window.open(fileURL,"_blank");

                commit('setLoading', false);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async requestXls({commit, dispatch}, {
            period_date_from,
            period_date_to,
            restaurant_id,
        }) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let url_params = `?period_date_from=${period_date_from}&period_date_to=${period_date_to}`;
                if (restaurant_id) {
                    url_params = url_params + '&restaurant_id=' + restaurant_id;
                }

                // window.open(`${this._vm.appConfig.app_url}/api/invoice${url_params}`);

                let response = await axios.get(`${this._vm.appConfig.app_url}/api/xls${url_params}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    responseType: 'blob',
                });

                download(response.data, `payments_${period_date_from}-${period_date_to}.xlsx`, response.headers['content-type']);

                commit('setLoading', false);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async fetchInvoiceCheck({ commit, dispatch }, {period_date_from, period_date_to, restaurant_id}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/invoice-check?period_date_from=${period_date_from}&period_date_to=${period_date_to}&restaurant_id=${restaurant_id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('fetchInvoiceCheck', data);
                return data;
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

    },


    getters: {
        invoices(state) {
            return state.invoices
        },
        invoices_period_date_from(state) {
            return state.period_date_from
        },
        invoices_period_date_to(state) {
            return state.period_date_to
        },
    }
}
